import { create } from 'zustand';

interface ScreenshotPopupState {
  isPopupVisible: boolean;
  streamId: string | null;
  fileKeyNames: string[];
  showPopup: () => void;
  hidePopup: () => void;
  updateStreamId: (id: string | null) => void;
  setFileKeyName: (keys: string[]) => void;
}

export const useScreenshotPopupStore = create<ScreenshotPopupState>()((set) => ({
  isPopupVisible: false,
  streamId: null,
  fileKeyNames: [],
  showPopup: () => set({ isPopupVisible: true }),
  hidePopup: () => set({ isPopupVisible: false }),
  updateStreamId: (streamId) => set({ streamId }),
  setFileKeyName: (fileKeyNames) => set({ fileKeyNames }),
}));

export type { ScreenshotPopupState };
